import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { isMobile } from 'swag-client-common/utils/ui.utils';
import { BOX_NOTECARD_STEPS } from '../../../redux/box-notecard-editor/box-notecard-editor.reducer';
import { LogoUploadStep } from './components/logo-upload-step';
import { TextEditorStep } from './components/text-editor-step';
import { ConfirmProvideLaterStep } from './components/confirm-step';
import { Buttons } from './components/buttons';
import css from './edit-box-notecard-popup.scss';
const classes = {
  paper: css.paper
};
const titleClasses = {
  root: css.header
};
const animationClasses = {
  enter: css.enter,
  enterActive: css.enterActive,
  exit: css.exit,
  exitActive: css.exitActive
};
const BOX_NOTECARD_STEPS_DIALOG = {
  [BOX_NOTECARD_STEPS.LOGO_AND_COLOR]: /*#__PURE__*/React.createElement(LogoUploadStep, null),
  [BOX_NOTECARD_STEPS.TEXT_CONTENT]: /*#__PURE__*/React.createElement(TextEditorStep, null),
  [BOX_NOTECARD_STEPS.CONFIRM_PROVIDE_LATER]: /*#__PURE__*/React.createElement(ConfirmProvideLaterStep, null)
};
export function EditBoxNotecardPopupComponent(props) {
  const {
    open,
    step,
    boxItemsId,
    onClose,
    onAddNotecard,
    onDeleteNotecard
  } = props;
  const isMobileView = isMobile();
  const MobileViewMessage = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, "Let\u2019s design your notecard!"), /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, "Please use dekstop version to design your box notecard"), /*#__PURE__*/React.createElement(Buttons, {
    nextText: "Add a notecard",
    backText: "I Don't Want A Notecard",
    onNextButton: () => {
      onAddNotecard(boxItemsId);
    },
    onBackButton: () => {
      onDeleteNotecard(boxItemsId);
    }
  }));
  const StepContent = /*#__PURE__*/React.createElement("div", {
    className: css.animatedContent
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: step,
    timeout: 200
  }, BOX_NOTECARD_STEPS_DIALOG[step])));
  const content = isMobileView ? MobileViewMessage : StepContent;
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    classes: classes,
    onClose: onClose,
    dataPopup: "EditBoxNotecardPopup",
    content: content,
    titleClasses: titleClasses,
    contentClass: css.contentWrapper,
    closeClass: css.closeClass
  });
}